export default "__VITE_ASSET__XZhk2FL6__"